module.exports = __webpack_public_path__ + "static/media/ready-service-icon-card.077a8af3.svg";